import { createContext, useContext } from 'react';
import type { CrewLookupKind } from './registry';

export const CrewLookupKindContext = createContext<CrewLookupKind | null>(null);

export function useCrewLookupKind(): CrewLookupKind {
  const kind = useContext(CrewLookupKindContext);
  if (!kind) throw new Error('CrewLookupKindContext missing');
  return kind;
}
